var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4233 12H21.3046V13.8247H24.4233V12Z",
    fill: "#40AB5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4233 14.5298H21.3046V16.3545H24.4233V14.5298Z",
    fill: "url(#paint0_linear_568:8)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4233 17.0596H21.3046V18.8843H24.4233V17.0596Z",
    fill: "url(#paint1_linear_568:8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1187 19.5894H10V21.4141H13.1187V19.5894Z",
    fill: "url(#paint2_linear_568:8)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8844 19.5894H13.7656V21.4141H16.8844V19.5894Z",
    fill: "url(#paint3_linear_568:8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6575 19.5894H17.5388V21.4141H20.6575V19.5894Z",
    fill: "url(#paint4_linear_568:8)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4233 19.5894H21.3046V21.4141H24.4233V19.5894Z",
    fill: "url(#paint5_linear_568:8)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6575 17.0596H17.5388V18.8843H20.6575V17.0596Z",
    fill: "url(#paint6_linear_568:8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8844 17.0596H13.7656V18.8843H16.8844V17.0596Z",
    fill: "url(#paint7_linear_568:8)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8844 14.5298H13.7656V16.3545H16.8844V14.5298Z",
    fill: "url(#paint8_linear_568:8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_568:8",
    x1: 22.8792,
    y1: 16.3703,
    x2: 22.8499,
    y2: 14.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5256,
    stopColor: "#33A65E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_568:8",
    x1: 21.2587,
    y1: 18.7906,
    x2: 24.4706,
    y2: 17.1541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_568:8",
    x1: 10.0006,
    y1: 20.5024,
    x2: 13.1167,
    y2: 20.5024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_568:8",
    x1: 13.7691,
    y1: 20.5024,
    x2: 16.8852,
    y2: 20.5024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_568:8",
    x1: 17.5379,
    y1: 20.5024,
    x2: 20.654,
    y2: 20.5024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_568:8",
    x1: 21.3029,
    y1: 20.5024,
    x2: 24.419,
    y2: 20.5024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_568:8",
    x1: 17.4149,
    y1: 18.4639,
    x2: 20.777,
    y2: 17.4808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_568:8",
    x1: 13.6582,
    y1: 17.3649,
    x2: 16.9961,
    y2: 18.5798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CE1938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_568:8",
    x1: 14.031,
    y1: 14.2462,
    x2: 16.6233,
    y2: 16.6383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5A22"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92806fac.svg";
export { ForwardRef as ReactComponent };